import { Flame, Wheat, TreePine, Car, Snowflake, CreditCard } from 'lucide-react';
import GlutenFreeIcon from '@/components/GlutenFreeIcon';

const features = [
  {
    icon: Flame,
    title: 'Forno a Legna',
    description: 'Impasti fatti da noi con ingredienti selezionati ogni giorno.',
    iconColor: 'text-primary',
    bgColor: 'bg-primary/10',
  },
  {
    icon: Wheat,
    title: 'Senza Glutine Certificato',
    description: 'Reparto separato con forno dedicato e certificazione AIC.',
    iconColor: 'text-green-500',
    bgColor: 'bg-green-500/10',
    useGlutenIcon: true,
  },
  {
    icon: TreePine,
    title: 'Tavoli & Dehor',
    description: 'Posti interni e spazio esterno per la bella stagione.',
    iconColor: 'text-emerald-600',
    bgColor: 'bg-emerald-600/10',
  },
  {
    icon: Car,
    title: 'Ampio Parcheggio',
    description: 'Comodo accesso anche nelle ore di punta.',
    iconColor: 'text-blue-500',
    bgColor: 'bg-blue-500/10',
  },
  {
    icon: Snowflake,
    title: 'Locale Climatizzato',
    description: 'Ambiente confortevole in ogni stagione.',
    iconColor: 'text-sky-400',
    bgColor: 'bg-sky-400/10',
  },
  {
    icon: CreditCard,
    title: 'Pagamenti Elettronici',
    description: 'Bancomat, carte di credito e Satispay accettati.',
    iconColor: 'text-violet-500',
    bgColor: 'bg-violet-500/10',
  },
];

const WhyChooseUs = () => {
  return (
    <section id="perche-noi" className="py-20 bg-card">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            Perché Scegliere Noi
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Qualità, comfort e attenzione al cliente in ogni dettaglio.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {features.map((feature) => (
            <div key={feature.title} className="card-elevated p-6 text-center">
              <div className="flex items-center justify-center mx-auto mb-4">
                {feature.useGlutenIcon ? (
                  <GlutenFreeIcon size={40} className={feature.iconColor} />
                ) : (
                  <feature.icon className={`h-10 w-10 ${feature.iconColor}`} />
                )}
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
